module.exports = "<div [chart]=\"stock\"\r\n    [ngStyle]=\"{'display':  infoCourbesHighC ? 'block' : 'none'}\"></div>\r\n"